<template>
  <InteractiveForm
    ref="rfUserForm"
    class="UserInteractiveForm"
    :steps="cptdSteps"
    :auto-selectable-steps="cptdAutoSelectableSteps"
    current-form="user"
    :busy="busy"
    @submit="submit"
  >
    <template #default="{ step, index, validation }">
      <FullNameInput
        v-if="displayInput(step, 'name')"
        key="name"
        v-model="usr.name"
        label="Qual seu nome completo?"
        :validation="validation"
      />
      <EmailInput
        v-if="displayInput(step, 'email')"
        key="email"
        v-model="usr.email"
        label="Qual seu e-mail?"
        helper-message="Para acessar sua conta no futuro e receber comunicações referente à simulação."
        :validation="validation"
        @blur="verifyIfOAuthEmailMatchesUserEmail"
      />
      <CpfInput
        v-if="displayInput(step, 'cpf')"
        key="cpf"
        v-model="usr.cpf"
        label="Qual é o seu CPF?"
        helper-message="Necessário para análise de crédito."
        :validation="validation"
      />

      <Checkbox
        v-if="displayInput(step, 'cpf')"
        id="communicationsAgreement"
        key="communicationsAgreement"
        v-model="communicationsAgreement"
        validations="checkboxRequired"
        :validation="validation"
        :background="false"
        :checked="communicationsAgreement"
      >
        Eu li e concordo com os
        <BaseLink
          href="https://jurosbaixos.com.br/termos-e-condicoes-de-uso-gerais/"
          target="_blank"
          >Termos de Uso</BaseLink
        >
        e
        <BaseLink
          href="https://jurosbaixos.com.br/termos-e-condicoes-de-uso-e-politica-de-privacidade/"
          target="_blank"
          >Política de Privacidade</BaseLink
        >.
      </Checkbox>
      <MobilePhoneInput
        v-if="displayInput(step, 'mobile_phone')"
        key="mobile_phone"
        v-model="usr.mobile_phone"
        label="Qual o número do seu celular?"
        helper-message="Informe o número com DDD."
        :validation="validation"
      />

      <Checkbox
        v-if="displayInput(step, 'mobile_phone')"
        id="termsAgreement"
        key="termsAgreement"
        v-model="termsAgreement"
        label="Eu aceito receber comunicações por e-mail, WhatsApp e SMS."
        validations="checkboxRequired"
        :background="false"
        :validation="validation"
        :checked="termsAgreement"
      />

      <div
        v-if="step === 'email' || step === 'cpf'"
        key="login-buttons"
        class="oauth-wrapper"
        :class="{ oauth: step === 'email' && !isWebView }"
      >
        <Button
          type="outlined"
          :busy="loading"
          @click="autoSelectField(step, usr[step])"
        >
          Continuar
        </Button>
        <div
          v-if="displayInput(step, 'email') && !isWebView"
          class="login-options"
        >
          <div class="divider">
            <div class="line" />
            OU
            <div class="line" />
          </div>
          <GoogleSignInButton
            context="register"
            :redirect="false"
            @registered="handleSocialRegister"
          />
          <MicrosoftSignInButton
            context="register"
            :redirect="false"
            @registered="handleSocialRegister"
          />
        </div>
        <div v-if="index === 0" class="form-steps oauth">
          <label>
            Apenas
            <strong>4 minutos e 30 segundos para ver o resultado</strong> da
            simulação.
          </label>
          <div class="steps">
            <SteppedInline
              :index="1"
              status="in-progress"
              direction="row"
              :first="true"
              :last="false"
            >
              Conta
            </SteppedInline>
            <SteppedInline
              :index="2"
              status="not-started"
              direction="row"
              :first="false"
              :last="false"
            >
              Simulação
            </SteppedInline>
            <SteppedInline
              :index="3"
              status="not-started"
              direction="row"
              :first="false"
              :last="true"
            >
              Ofertas
            </SteppedInline>
          </div>
        </div>
      </div>
    </template>
  </InteractiveForm>
</template>
<script>
import { nextTick } from 'vue'
import InteractiveForm from '~/components/forms/InteractiveForm.vue'
import MobilePhoneInput from '~/components/forms/fields/input/MobilePhoneInput.vue'
import CpfInput from '~/components/forms/fields/input/CpfInput.vue'
import EmailInput from '~/components/forms/fields/input/EmailInput.vue'
import FullNameInput from '~/components/forms/fields/input/FullNameInput.vue'
import BaseLink from '~/aasgard/components/base/BaseLink.vue'
import Checkbox from '~/components/ui/newComponents/Checkbox.vue'
import GoogleSignInButton from '~/containers/oauth/providers/GoogleSignInButton.vue'
import MicrosoftSignInButton from '~/containers/oauth/providers/MicrosoftSignInButton.vue'
import Button from '~/aasgard/components/buttons/Button.vue'
import { isWebView } from '~/helpers/globalFunctions'
import SteppedInline from '~/aasgard/components/feedback/SteppedInline.vue'
export default {
  name: 'UserInteractiveForm',
  components: {
    SteppedInline,
    Button,
    MicrosoftSignInButton,
    GoogleSignInButton,
    Checkbox,
    BaseLink,
    InteractiveForm,
    MobilePhoneInput,
    CpfInput,
    EmailInput,
    FullNameInput,
  },
  props: {
    busy: { type: Boolean, default: false },
    user: { type: Object, default: () => ({}) },
  },
  emits: ['submit', 'primary-key-changed', 'oauth-change'],
  data() {
    return {
      loading: false,
      usr: {
        cpf: '',
        email: '',
        mobile_phone: '',
        name: '',
      },
      oauth: {
        accessToken: '',
        email: '',
        provider: '',
      },
      termsAgreement: false,
      communicationsAgreement: false,
      isWebView,
    }
  },
  computed: {
    cptdAutoSelectableSteps() {
      return ['cpf', 'email']
    },
    cptdSteps() {
      return ['cpf', 'email', 'mobile_phone', 'name']
    },
  },
  mounted() {
    this.usr = {
      cpf: this.user?.cpf ?? '',
      email: this.user?.email ?? '',
      mobile_phone: this.user?.mobile_phone ?? '',
      name: this.user?.name ?? '',
    }
  },
  methods: {
    displayInput(step, key) {
      return step === key
    },
    submit() {
      this.$emit('submit', {
        user: this.usr,
        accessToken: this.oauth.accessToken,
        provider: this.oauth.provider,
      })
    },
    autoSelectField(key, value, emitEvent = true) {
      this.usr[key] = value

      nextTick(async () => {
        await this.$refs.rfUserForm.next()
        if (this.$refs.rfUserForm.formIsValid) {
          if (key === 'email' || key === 'cpf') {
            if (emitEvent) {
              this.$emit('primary-key-changed', { type: key, value })
            }
          }
        }
      })
    },
    handleSocialRegister({ accessToken, email, name, provider }) {
      this.oauth.accessToken = accessToken
      this.oauth.provider = provider
      this.oauth.email = email
      this.usr.email = email
      this.usr.name = name

      this.$emit('oauth-change', { accessToken, provider, email })
      this.autoSelectField('email', email, false)
    },
    verifyIfOAuthEmailMatchesUserEmail() {
      if (this.oauth.provider && this.oauth.accessToken && this.oauth.email) {
        if (this.usr.email !== this.oauth.email) {
          this.oauth.accessToken = ''
          this.oauth.provider = ''
          this.oauth.email = ''
        }
      }
    },
  },
}
</script>
<style lang="scss">
.UserInteractiveForm {
  .oauth-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0 0 24px 0;

    & > .Button {
      align-self: flex-start;
    }

    &.oauth {
      & > .Button {
        width: 100%;
        max-width: 300px;
        margin: 8px auto 0 auto;
      }
    }

    & > .login-options {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      width: 100%;

      & > .divider {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        color: $color-black-medium;
        @include body-2;

        & > .line {
          width: 100%;
          height: 1px;
          background-color: $color-neutral-dark;
        }
      }
    }

    & > .form-steps {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 24px;
      gap: 16px;
      border-radius: 12px;
      border: 1px solid $color-neutral;
      background: $color-white-high;
      color: $color-black-high;
      @include body-2;

      & > .steps {
        display: flex;
      }
    }
  }
}
</style>
